<!--<meta http-equiv="Content-Security-Policy" content="upgrade-insecure-requests">-->
<!--
<app-st-header>
  <ng-container ngProjectAs="app-brand">
    <a href="https://www.scalanthropy.com" target="_blank">
      <img src="assets/images/Scalanthropy_logo.png"  alt="Logo" width="200" height="80" class="display-2 d-inline-block align-text-top"
    ></a>
  </ng-container>
</app-st-header>-->
<!--
<br>
<div class="st-form">
  <a href="https://www.scalanthropy.com" target="_blank">
    <img src="assets/images/Scalanthropy_logo.png"  alt="Logo" width="200" height="80" class="display-2 d-inline-block align-text-top">
  </a>
</div>
<hr class="solid">-->
<div class="grad-background">
  <br>
  <router-outlet></router-outlet>
  <br><br><br>
  <app-st-footer [idVal]="'footer-id'"></app-st-footer>
</div>


<!--(click)="goToHomePage()"-->

